import React, { useEffect, useState } from "react";

export default function StateSelectOption() {
  // State variables
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [newCategory, setNewCategory] = useState("");
  const [options, setOptions] = useState([]);
  const [showInputField, setShowInputField] = useState(false);

  useEffect(() => {
    // Initialize options with default values
    setOptions([
      "Kansas",
      "Alabama",
      "Alaska",
      "Arizona",
      "California",
      "Colorado",
    ]);
  }, []);

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Handle click on existing option
  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  // Handle click on add category button
  const handleAddButtonClick = () => {
    setShowInputField(true);
  };

  // Handle click on create button
  const handleCreateButtonClick = () => {
    if (newCategory.trim() !== "") {
      setOptions([...options, newCategory]);
      setNewCategory("");
      setShowInputField(false);
    }
  };

  return (
    <div className='accordion '>
      <div
        className={`accordion-header  ${isOpen ? "active" : ""}`}
        onClick={toggleDropdown}
        style={{ height: "60px", borderRadius: "8px" }}>
        <span className='selected-option '>{selectedOption}</span>
        <span className='icon overflow-hidden'>
          <i
            className={
              isOpen ? "fa-solid fa-caret-up" : "fa-solid fa-caret-down"
            }
          />
        </span>
      </div>
      <div className={`accordion-content ${isOpen ? "active" : ""}`}>
        {/* Render existing options */}
        {options.map((option, index) => (
          <div
            key={index}
            className='option'
            onClick={() => handleOptionClick(option)}>
            {option}
          </div>
        ))}
        {/* Render input field for new category */}
        {showInputField ? (
          <div className='input-with-button d-flex align-items-center'>
            <input
              type='text'
              placeholder=' New Category..'
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
            />
            <button id='createButton' onClick={handleCreateButtonClick}>
              Create
            </button>
          </div>
        ) : (
          // Render add category button
          <button id='button' onClick={handleAddButtonClick}>
            + Add Category
          </button>
        )}
      </div>
    </div>
  );
}
